import { Tag, Typography } from '@project44/manifest-ds';

import { Item, List } from './styles';

interface ReferenceKeyItemProps {
  onTagClick?: (value: string) => void;
  data: string[];
  label: string;
}

export const ReferenceKeyItem = ({
  label,
  data,
  onTagClick,
}: ReferenceKeyItemProps) => {
  return (
    <Item data-testid="reference-key-item">
      <Typography variant="subtext">{label}</Typography>
      <List>
        {data.map((value) => (
          <Tag
            key={value}
            label={value}
            isCopyable={!!onTagClick}
            onClick={() => onTagClick?.(value)}
            data-testid="reference-key-item-click"
            css={{ maxWidth: '400px' }}
          >
            {value}
          </Tag>
        ))}
      </List>
    </Item>
  );
};
